export default __webpack_public_path__ + "static/4_37-688dcba499b4814a386f5720e4bfc2d9.png";